/*@ngInject*/
module.exports = function (data, systemIcons, $uibModalInstance) {
    const vm = this;

    vm.object = data.object;
    vm.features = data.features;
    vm.classifiers = data.classifiers;
    vm.modalInstace = $uibModalInstance;

    vm.icons = {};

    vm.$onInit = () => {
        angular.forEach(systemIcons.features, (icons, iconType) => {
            vm.icons[iconType] = [];
            angular.forEach(icons, (icon) => {
                const classifier = getClassifier(icon);
                if (classifier) {
                    vm.icons[iconType].push({
                        iconCode: icon,
                        classifierId: classifier.id,
                        name: classifier.name,
                        order: classifier.int,
                        selected: vm.features.includes(classifier.id)
                    });
                }
            });
            if (vm.icons[iconType].length === 0) {
                delete vm.icons[iconType];
            }
        });
    };

    function getClassifier(icon) {
        return _.find(vm.classifiers, x => x.icon_path === icon);
    }

    vm.save = () => {
        let features = [];
        angular.forEach(vm.icons, (icons) => {
            angular.forEach(icons, (icon) => {
                if (icon.selected) {
                    features.push(icon.classifierId);
                }
            });
        });
        vm.features = features;
        vm.modalInstace.close(vm.features);
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/objects/edit/directives/objects-edit-features-modal.directive.js
 **/